/**
 * @file User slug based routes.
 */

import loadable from '@loadable/component';

import RequireValidSlug from '../components/routing/RequireValidSlug';
import LoadableFullScreenLoader from '../components/global/loadable/LoadableFullScreenLoader';

const WebGalleryMasterRouteLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "WebGalleryMasterRoute" */ '../apps/web-gallery/routes/WebGalleryMasterRoute'
    ),
  { fallback: LoadableFullScreenLoader },
);

const routes = [
  {
    path: '/:slug',
    exact: false,
    component: RequireValidSlug(WebGalleryMasterRouteLoadable),
  },
];

export default routes;
